import type { BarColors } from '@ui-kit/components/Bars/TopBar/types'
import type { Color } from '@ui-kit/types'

const mapBgColorToTypoColor: Record<BarColors, Color> = {
  brandLight: 'brandDark',
  uiOrangeLight: 'uiOrange',
  uiRedLight: 'uiRed',
  playground4Light: 'playground4Dark',
  brandLime: 'brandDark',
  uiGreenLight: 'uiGreen',
  uiGreyMedium: 'uiDarkMedium',
  uiDark: 'uiLight',
  uiGreenOverlay: 'uiGreenOverlay',
}

export const getFontColor = (bgColor?: BarColors): Color =>
  (bgColor && mapBgColorToTypoColor[bgColor]) || 'playground4Dark'
